import Button from 'src/components/design-system/Button';
import useBoolean from 'src/hooks/useBoolean';
import useViewCheckbook from 'src/hooks/useViewCheckbook';
import AttributesTable from 'src/sections/view_checkbook/attributes/AttributesTable';
import { AttributesType } from 'src/sections/view_checkbook/attributes/AttributesTableToolbar';
import { ClientResponse } from 'src/services/company/useGetClientsQuery';
import {
  getApprovalStatus,
  GlApproval,
  GLCodePeriodBudgetResponse,
} from 'src/services/useGlCodePeriodBudgetApi';

export const transformData = (data: GLCodePeriodBudgetResponse, users: ClientResponse[]) => {
  const result: AttributesType[] = [];

  const { code, description, invoiceGlApproval, poGlApproval } = data;

  const findUser = (id: number) => users.find((cl) => cl.clientId === id)?.name;
  const handleApproval = (approval: GlApproval | undefined, type: string) => {
    if (approval) {
      const { status, clientIds } = approval;
      if (clientIds.length > 0) {
        clientIds.forEach((clientId: any) => {
          result.push({
            glCode: code,
            description,
            invoice: type + ' - ' + getApprovalStatus(status),
            user: `${findUser(clientId)}`,
          });
        });
      } else {
        result.push({
          glCode: code,
          description,
          invoice: type + ' - ' + getApprovalStatus(status),
          user: 'N/A',
        });
      }
    }
  };

  handleApproval(invoiceGlApproval, 'Invoice');
  handleApproval(poGlApproval, 'PO');

  return result;
};

const ViewAllAttributeUserAssignments = () => {
  const { value: openAssignmentsModal, toggle: toggleAssignmentsModal } = useBoolean();

  const { clients, allDeptGLCodes, t } = useViewCheckbook();

  const attributesData = allDeptGLCodes.flatMap((budget) => transformData(budget, clients));

  return (
    <>
      <Button color="secondary" onClick={toggleAssignmentsModal}>
        {t('View All Attribute Contact Assignments')}
      </Button>
      <AttributesTable
        openAssignmentsModal={openAssignmentsModal}
        toggleAssignmentsModal={toggleAssignmentsModal}
        GLCodeAttributesData={attributesData}
        title="View All GL Code Attributes and Assignments"
      />
    </>
  );
};

export default ViewAllAttributeUserAssignments;
